import React, {Component} from 'react';
import NotFoundPage from '../NotFoundPage';
import queryString from 'qs';
import AssessmentPage from './AssessmentPage';
import GreenLeafApi from '../utils/GreenLeafApi';
import ErrorComponent from '../ErrorComponent';

class GroupAssessment extends Component {
  constructor(props) {
    super(props);

    this.state = {
      answers: {},
      errors: null,
      saved: false,
      token: null,
      notFound: false,
      isLoading: true,
      subsections: [],
      invite: null
    };
  }

  componentWillMount() {
    let { token } = queryString.parse(this.props.location.search.slice(1));
    if (token) {
      this.setState({ token });
    } else {
      this.setState({ notFound: true});
    }
  }

  async componentDidMount() {
    if (this.state.token) {
      try {
        let invite = await GreenLeafApi.GroupTeamAssessment.getInvite(this.state.token);

        if (invite.data.invite) {
          let subs = await GreenLeafApi.Assessment.getSubs({group_team_assessment_id: invite.data.invite.group_assessment_id});
          if (subs.isOkay) {
            this.setState({ subsections: subs.data.assessment });
          }
          invite = invite.data.invite;
          this.setState({ invite });

          if (invite.complete) {
            this.setState({ errors: [{ msg: 'You have already completed this survey.' }] });
          } else if (invite.group_assessment_closed) {
            this.setState({ errors: [{ msg: 'This survey has been closed.' }] });
          }
        } else {
          this.setState({ notFound: true });
        }
      } catch (e) {
        this.setState({ errors: e.errors });
      }
    }

    this.setState({ isLoading: false });
  }

  onSubmit = async () => {
    const answers = [];
    Object.keys(this.state.answers).forEach(id => {
      answers.push({question_id: id, answer_id: this.state.answers[id].answer, comment: this.state.answers[id].comment});
    });

    try {
      await GreenLeafApi.GroupTeamAssessment.submit(answers, this.state.token);
      this.setState({ saved: true });
    } catch (e) {
      this.setState({ errors: [{ code: 0, msg: 'Error submitting survey. Please try again later.' }] });
    }
  };

  onChangeComment = (question_id, comment) => {
    this.setState((prevState) => ({
        answers: {
          ...prevState.answers,
          [question_id]: { answer: (this.state.answers[question_id] || {}).answer, comment }
        }
    }));
  };

  onChange = (question_id, answer) => {
    this.setState(prevState => ({
      answers: {
        ...prevState.answers,
        [question_id]: answer
      }
    }));
  };

  render() {
    if (this.state.isLoading) {
      return <p>Loading...</p>;
    }
    if (this.state.notFound) {
      return <NotFoundPage/>;
    }
    if (this.state.saved) {
      return <p className='ta-center'>Survey successfully completed! Thanks for your help!</p>;
    }
    if (this.state.errors) {
      return <ErrorComponent error={this.state.errors}/>;
    }

    return (
      <div>
        <p>Please complete the survey. Answers are saved anonymously.</p>
        <br/>
        <AssessmentPage
          assessmentId={this.state.invite.assessment_id}
          answers={this.state.answers}
          onSubmit={this.onSubmit}
          onChangeComment={this.onChangeComment}
          onChange={this.onChange}
          assessment={this.state.subsections}
        />
      </div>
    );
  }
}

export default GroupAssessment;



// WEBPACK FOOTER //
// ./src/components/teams/GroupAssessment.js